import gql from "graphql-tag";

export const GET_MY_BATCHES = gql`
    query BatchTable($orgId: uuid!){
        BatchTable(where: {_and: [{ownedBy: {_eq: $orgId}},{status: {_eq: "InStock"}}]},order_by: {createdOn: desc}){
            id
            productId
            sku
            batch
            Product{name productLineCode}
        }
    }
`
export const GET_INVENTORY_BATCHES = gql`
    query BatchTable($orgId: uuid!){
        InventoryItems: BatchTable(where: {_and: [{ownedBy: {_eq: $orgId}},{status: {_eq: "InStock"}}]}){
            batch
        }
    }
`
export const GET_MY_BATCHES_GROUP_BY_PRODUCT = gql`
    query Product($orgId: uuid!,  $filter:String!){
        Product(order_by: {name: asc}){
            id
            name
            RDPrice
            RPPrice
            NDPrice
            VADPrice
            VPPrice
            VAPPrice
            batches_aggregate(where: {ownedBy: {_eq: $orgId}, status: {_eq: "InStock"}, batch: {_ilike: $filter}}) {
                aggregate {
                    count
                }
            }
        }
    }`

    export const GET_MY_BATCHES_GROUP_BY_PRODUCT_ONLINE = gql`
    query OnlineProducts($orgId: uuid!,  $filter:String!){
        OnlineProducts(order_by: {name: asc}){
            id
            name
            pricing
            batches_aggregate:Batches_aggregate(where: {ownedBy: {_eq: $orgId}, status: {_eq: "InStock"}, batch: {_ilike: $filter}}) {
                aggregate {
                    count
                }
            }
        }
    }`
export const GET_PRODUCT_DETAIL_BY_ID = gql`
    query Product($productId: uuid!){
        Product(where: {id: {_eq: $productId}}){
            id
            name
            description
            oemCode
            productLineCode
            sku
            unit
        }
    }
`

export const GET_PRODUCT_DETAIL_BY_ID_ONLINE = gql`
    query OnlineProducts($productId: uuid!){
        OnlineProducts(where: {id: {_eq: $productId}}){
            id
            name
            description
            oemCode
            productLineCode
            sku
            unit
        }
    }
`

export const GET_PRODUCT_BATCHES = gql`
    query BatchTable($orgId: uuid!, $productId: uuid!, $filter:String!){
        BatchTable(where: {ownedBy: {_eq: $orgId}, productId: {_eq: $productId}, status: {_eq: "InStock"}, batch: {_ilike: $filter}}, order_by: {batch: asc}) {
            id
            batch
            expiryDate
        }
    }
`

export const GET_PRODUCT_BATCHES_ONLINE = gql`
    query OnlineBatches($orgId: uuid!, $productId: uuid!, $filter:String!){
        OnlineBatches(where: {ownedBy: {_eq: $orgId}, productId: {_eq: $productId}, status: {_eq: "InStock"}, batch: {_ilike: $filter}}, order_by: {batch: asc}) {
            id
            batch
            expiryDate
        }
    }
`

export const GET_ACTIVE_SUB_BATCH_WITH_LIMIT = gql`
query getActiveSubBatchWithLimit($orgId: uuid!, $limit: Int!, $offset: Int!, $filter: String!){
  batches: BatchTable(where: {ProductInventories: {ownedBy: {_eq: $orgId}, isActivated: {_eq: true}, status: {_eq: "InStock"}}, batch:{_ilike: $filter}}, offset: $offset, limit: $limit){
     id
     batch
     Product { id name }
     subBatches: ProductInventories(where: {ownedBy: {_eq: $orgId}, isActivated: {_eq: true}, status: {_eq: "InStock"}}) {
       id 
       serial  
     }                
  }
}`

export const GET_ACTIVE_SUB_BATCH_TOTAL_COUNT = gql`
query getActiveSubBatchTotalCount($orgId: uuid!, $filter: String!){
  batchesCount: BatchTable_aggregate(where: {ProductInventories: {ownedBy: {_eq: $orgId}, isActivated: {_eq: true}, status: {_eq: "InStock"}}, batch:{_ilike: $filter}}){
    aggregate{count}
  }
}`

export const GET_BATCH_FROM_BATCHNO = gql`
    query($batch:String!){
        BatchTable(where:{batch:{_eq:$batch}}){
            id
            ownedBy
            createdOn
            sku
            batch
            CreatedBy{id name}
            OwnedBy{id name}
        }
    }
`

export const GET_ORDER_HISTORY = gql`
    query ($batch:String!,$sortBy: [Orders_order_by!]) {
        Orders(where: {OrderItems: {Batch: {batch: {_eq: $batch}}}}, order_by: $sortBy) {
            id
            createdOn
            from
            orderNum
            placedBy
            status
            date
            to
            updatedOn
            orderType
            ToCustomer{name}
            PlacedBy{id name}
            FromOrganization{id name PartnerType{  id prefix }}
            ToOrganization{id name PartnerType{  id prefix }}
        }
    }`
